export default __webpack_public_path__ + "static/media/Bracers of the Ichorous.6252e083.jpg";